import { message } from "antd";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { useGlobalStore } from "@/store/GlobalStore";
import { isDev } from "project-config/utils/env";

export function useInviteRewards() {
  const t = getTranslateNsT("center");

  const { userInfo, isPictureUser } = useGlobalStore();
  const url = isDev()
    ? `https://task-pre.renderbus.com/sso/${
        isPictureUser ? "picture-invite" : "register"
      }`
    : `https://task.renderbus.com/sso/${
        isPictureUser ? "picture-invite" : "register"
      }`;
  const link = `${url}?businessType=${userInfo?.businessType}${
    isPictureUser ? "&source=2" : ""
  }&inviteId=${userInfo?.userId}`;

  const handleCopy = () => {
    navigator.clipboard.writeText(
      link +
        `\n${
          isPictureUser
            ? t("picture_reward_copt_text1")
            : t("animation_reward_copt_text")
        }`
    );
    message.success(t("invite_copy_success"));
  };

  return {
    link,
    handleCopy,
  };
}
